/* eslint-disable indent */
import styled from "styled-components";

import { Button } from "@/components/ui/button";
import { PopoverContent as StyledPopoverContent } from "@/components/ui/popover";
import { device } from "@/utils/sizes";
import { colourScheme } from "utils/styling/colours";

export const Container = styled.div`
    width: 100%; /* Full width */
    display: flex;
    justify-content: space-between; /* Adjust if you need different alignment */
    align-items: center;
    flex-direction: column;
`;
export const ControlsContainer = styled.div`
    padding: 0.5rem;
    background-color: ${colourScheme.primaryLight};
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 0.5rem;
    width: 100%;
`;

export const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
`;

// Styled button with dynamic background and text color based on props
export const ActionButton = styled.button<{
    $isLiked?: boolean;
}>`
    background-color: ${(props) =>
        props.$isLiked
            ? "rgba(244, 63, 94, 0.2)"
            : "transparent"}; /* Tailwind: bg-rose-500/20 */
    color: ${(props) =>
        props.$isLiked
            ? "#F43F5E"
            : "white"}; /* Tailwind: text-rose-500 or text-white */
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem; /* Tailwind: space-x-1 */
    padding: 0.5rem;
    border-radius: 0.25rem;
    &:hover {
        color: ${(props) =>
            props.$isLiked
                ? "#F43F5E"
                : "#E11D48"}; /* Tailwind: hover:text-rose-500 */
    }
`;

// Button used for icons (like Share, Eye, More)
export const IconButton = styled(Button)`
    background: transparent;
    border: none;
    cursor: pointer;
    color: ${colourScheme.white};
    height: 2rem; /* Tailwind: h-8 */
    width: 2rem; /* Tailwind: w-8 */
    &:hover {
        color: ${colourScheme.grey};
    }
`;

export const TogglePublicButton = styled(Button)<{ $isPublic?: boolean }>`
    background: transparent;
    border: none;
    cursor: pointer;
    color: ${(props) => (props.$isPublic ? "#0EA5E9" : colourScheme.white)};
    align-self: center;
    height: 2rem;
    width: 2rem;
    &:hover {
        color: ${(props) => (props.$isPublic ? "#38BDF8" : "#CBD5E1")};
    }
`;

export const VisibilityMessage = styled.div`
    font-size: 0.75rem;
    color: ${colourScheme.grey};
    padding: 0 0.5rem 0.5rem 0.5rem;

    /* Hides on medium screens and above */
    ${device.md} {
        display: none;
    }
`;

export const TooltipContentWrapper = styled.div`
    max-width: 16rem;
    padding: 0.5rem;
`;

export const TooltipText = styled.p`
    font-size: 0.875rem;
    color: ${colourScheme.grey};
    margin-top: 0.25rem;
`;

export const PopoverItem = styled(Button)`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    padding: 0.5rem 0.8rem;
    background: transparent;
    border: none;
    color: ${colourScheme.white};
    cursor: pointer;
    transition:
        transform 0.1s ease-in-out,
        background-color 0.1s ease-in-out;
    justify-content: flex-start;

    &:hover {
        background-color: ${colourScheme.primaryLight};
        transform: scale(1.03);
        color: ${colourScheme.fullWhite};
    }

    &:focus {
        outline: none;
    }

    & > span {
        white-space: nowrap;
    }

    & > svg {
        width: 1rem;
        height: 1rem;
    }
`;

export const PopoverContent = styled(StyledPopoverContent)`
    width: 100%;
    background-color: ${colourScheme.primary};
    border: 1px solid ${colourScheme.primaryLight};
    padding: 0.5rem;
    display: grid;
    gap: 0.5rem;
    border-radius: 0.25rem;
`;
